import { Component, ViewEncapsulation } from "@angular/core";
import { CHDbObject, DbObject } from "@app/shared/model/db-object.model";
import { ConfirmationAction } from "../../../project/store/actions/generic.action";

@Component({
    selector: "app-delete-confirmation",
    templateUrl: "./delete-confirmation.component.html",
    styleUrls: ["./delete-confirmation.component.scss"],
    encapsulation: ViewEncapsulation.None,
})
export class DeleteConfirmationComponent {
    confirmationActionData: (DbObject | CHDbObject) & { warning?: string };
    display: string;
    // really should be "Delete" | "Remove" | "Deactivate" | "Activate" | "Suspend" | "Reset", but localization complpicates this
    actionTitle = $localize`:@@SHARED.TEXT.DELETE:Delete`;
    suffix = "";
    confirmationData: ConfirmationAction = null;
    confirmationText = "";

    private getObjectType<T extends DbObject | CHDbObject | any>(obj: T) {
        const type = (obj?.constructor as typeof DbObject | typeof CHDbObject)?.dbTypeName;
        if (this.confirmationActionData?.warning) {
            return type ? `this ${type}? ${this.confirmationActionData.warning}.` : `${this.confirmationActionData.warning}.`;
        }

        if (!this.display) {
            return $localize`this ${type}?`;
        }
        return `<span>${this.display}</span>${this.suffix}?`;
    }

    get dialogContent(): string {
        return $localize`Are you sure you want to ${this.actionTitle.toLowerCase()} ${this.objectTypeToDisplay}`;
    }

    get objectTypeToDisplay() {
        return this.getObjectType(this.confirmationActionData);
    }

    get isAbleToConfirm() {
        return !this.confirmationData || this.hasMatchingConfirmationValue;
    }

    get hasMatchingConfirmationValue(): boolean {
        return this.confirmationData.confirmValue === this.confirmationText;
    }
}
